import styled from 'styled-components';
const Wrapper = styled.div `
  padding-top: 1rem;
  padding-bottom: 1rem;
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  
  > * {
    width: 100%;
  }
`;
const ConfirmButton = styled.button `
  width: 100%;
`;
export default {
    Wrapper,
    ConfirmButton,
};
